import React from "react";

const Section6 = ({products, select, setSelect,step,setStep}) => {

    let price = 0.0;
    let course = document.querySelector('#course');

    function PriceInUAH(){
        if (course !== null && parseFloat(course.innerText) > 0){
            return(`${window.lang['s']['table_headers']['price']}: ${parseInt(price * parseFloat(course.innerText)).toFixed(2)} ${window.lang['s']['units']['uah']}`);
        } else {
            return null;
        }
    }

    price  = Object.values(select.basicPrice).reduce((sum, elem) => sum + parseFloat(elem)); //sum basic price

    if (Object.keys(select.options).length > 0 ){
        price *= Object.values(select.options).reduce((sum, elem) => {
            if (sum === 0) { //init starting coeficient = 1
                sum = 1;
            }
    
            let tmp = parseFloat(elem);
            if (tmp === 0) { // if option coef value = 0 or epmty string - set it to 1
                tmp = 1;    // otherwise multiplication will destroy all basic prices and options
            }
    
            sum *= parseFloat(tmp);
            return sum;
        });
    }


    if (Object.keys(select.finalPrice).length > 0 ){
        price += Object.values(select.finalPrice).reduce((sum, elem) => sum + parseFloat(elem)); //additive costs
    }

    if (select.calculatedPrice === -1){
        price = parseInt(price)
        setSelect({
            ...select,
            calculatedPrice: price
        })
    }

    function saveOrder(){
        localStorage.setItem(select.created, JSON.stringify(select))
        setStep(0)
    }

    function goBack(){
        setSelect({            
            ...select,
            calculatedPrice: -1
        })
        setStep(5)
    }

    let response = `
    ${window.lang['s6']['current_order']}:
        ${window.lang['s']['table_headers']['material']}: ${products[select.material].name}
        ${window.lang['s']['table_headers']['options']}:
        ${Object.getOwnPropertyNames(select.options).join('\n      ')}
        ${window.lang['s']['table_headers']['size']}: ${select.length}${window.lang['s']['units']['cm']} x ${select.height}${window.lang['s']['units']['cm']} 
        ${select.cutStyle ? window.lang['s']['in_cut'] : window.lang['s']['in_rolls']}${select.cut_flag ? ', ' + window.lang['s']['flagged'] : ''} ${select.amount} ${select.cutStyle ? window.lang['s']['units']['count'] : window.lang['s']['units']['rolls']}${!select.cutStyle ? ` (${select.amount*select.roll_length}${window.lang['s']['units']['meters']})` : null}
        ${window.lang['s']['table_headers']['colours']}: ${window.lang['s']['background']} ${select.colors.main} / ${window.lang['s']['logo']} ${select.colors.other}
        ${window.lang['s']['table_headers']['price']}: ${price.toFixed(2)} $ / ${PriceInUAH()} ${window.lang['s']['units']['uah']}
    `

    function SectionHeader(){
        if ( typeof(Storage) === "undefined" ){

                let calcForm = document.querySelector('section#calc-form')
                calcForm.style.display = 'block'
                calcForm.querySelector('input[name="select-data"]').value = response

                //show form, so user can only send this single order

            return(
                <div className="section_header">
                    <h1>{window.lang['s6']['title_no_localsorage']}</h1>
                </div>
            )
        } else {
            // saving order

            return(
                <>
                <div className="section_header">
                    <h1>{window.lang['s6']['title']}</h1>
                    <div className="step-btns">
                        <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s6']['btn_prev']}</span></button>
                        <button className="btn btn-save-order" onClick={() => saveOrder()} ><span>{window.lang['s6']['btn_next']}</span></button>
                    </div>
                </div>
                <h3>{window.lang['s6']['current_order']}</h3>
                <div className="orders-table single-order">

                    <span className="header">{window.lang['s']['table_headers']['material']}</span>
                    <span className="header">{window.lang['s']['table_headers']['options']}</span>
                    <span className="header">{window.lang['s']['table_headers']['size']}</span>
                    <span className="header">{window.lang['s']['table_headers']['cut']}</span>
                    <span className="header">{window.lang['s']['table_headers']['colours']}</span>
                    <span className="header">{window.lang['s']['table_headers']['price']}</span>

                    <span>{products[select.material].name}</span>
                    <span>{select.optionNames.join(`, `)}</span>
                    <span>{select.length}{window.lang['s']['units']['cm']} x {select.height}{window.lang['s']['units']['cm']}</span>
                    <span>{select.cutStyle ? window.lang['s']['in_cut'] : window.lang['s']['in_rolls']}{select.cut_flag ? ', ' + window.lang['s']['flagged'] : ''} <br/>{select.amount} {select.cutStyle ? window.lang['s']['units']['count'] : window.lang['s']['units']['rolls']}{!select.cutStyle ? ' ('+(select.amount*select.roll_length)+' '+window.lang['s']['units']['meters'] : null }</span>
                    <span>{window.lang['s']['background']} {select.colors.main} <br/>{window.lang['s']['logo']} {select.colors.other}</span>
                    <span>{parseInt(select.calculatedPrice * parseFloat(course.innerText))} {window.lang['s']['units']['uah']}</span>
                    
                </div>
                </>
            )
        }
    }

    function CheckInfo(){
        if (document.querySelector('#root.ruv') !== null) {
            return(
                <>
                    <hr/>
                    <h3>Инфо для проверки</h3>
                    <pre>
                        {response}
                    </pre>

                    <div style={{
                        backgroundColor: "#ddd5",
                        padding: "1em"
                        }}>
                        <h5>Для проверки, использовано в расчёте:</h5>
                        <p>Начальные Цены:</p>
                        <pre style={{
                        backgroundColor: "#ddd5",
                        padding: "1em"
                        }}>
                        {JSON.stringify(select.basicPrice, null, "    ")}
                        </pre>
                        <p>Опции:</p>
                        <pre style={{
                        backgroundColor: "#ddd5",
                        padding: "1em"
                        }}>{JSON.stringify(select.options, null, "    ")}
                        </pre>
                        <p>Дополнительно к конечной цене:</p>
                        <pre style={{
                        backgroundColor: "#ddd5",
                        padding: "1em"
                        }}>{JSON.stringify(select.finalPrice, null, "    ")}
                        </pre>
                    </div>
                </>
            )
        }else{
            return null;
        }
    }

    return(
        <>
            <SectionHeader />

            <CheckInfo />
        </>
    )
}
export default Section6;